import { PageDto } from "./product-v2";

export interface RequestMeta {
    method: string;
    url: string;
    userAgent?: string;
    ip?: string;
    userId?: string;
    timestamp: string;
    username?: string;
}

export interface ErrorMeta {
    message: string;
    name: string;
    stack?: string;
    code?: string;
    status?: number;
    statusText?: string;
    url?: string;
    data?: any;
}

export interface BulkInfo {
    total: number;
    successful?: number;
    failed?: number;
    errorCount?: number;
    entityType?: string;
}

export interface ErrorSummary {
    timestamp: string;
    error: string;
}

export interface ParentNotificationMeta {
    request: RequestMeta;
    bulkInfo: BulkInfo;
    errors?: ErrorSummary[];
    errorCount?: number;
    details?: any;
}

export interface ChildNotificationMeta {
    request: RequestMeta;
    error: ErrorMeta;
}

export type NotificationMetaType =
    | ParentNotificationMeta
    | ChildNotificationMeta
    | any;

export interface Notification {
    id: string;
    userId: string;
    storeId: string;
    type: NotificationType;
    title: string;
    body: string;
    severity: NotificationSeverity;
    meta: any;
    isRead: boolean;
    readAt: Date | null;
    filename: string | null;
    deliveredAt: Date | null;
    deliveredChannel: string | null;
    correlationId: string | null;
    source: string | null;
    createdAt: Date;
    updatedAt: Date;
    deletedAt: Date | null;
    expiresAt: Date | null;
}

export interface NotificationMeta {
    id?: string;
    process?: string;
    status?: string;
    title?: string;
    body?: string;
    detail?: any;
    type?: NotificationType | string;
    result?: any;
    error?: any;
    bulkInfo?: any;
    productNotExist?: string[];
}

export interface NotificationFilters {
    isRead?: boolean;
    severity?: NotificationSeverity;
    source?: string;
    type?: NotificationType;
    correlationId?: string | null;
}

export interface ListNotificationParams {
    userId: string;
    storeId: string;
    page?: number;
    size?: number;
    filters?: NotificationFilters;
}

export interface NotificationListResponse {
    items: Notification[];
    page: PageDto;
}

export interface CreateNotificationRequest {
    storeId: string;
    userId: string;
    type: NotificationType;
    title: string;
    body: string;
    severity?: NotificationSeverity;
    source?: string;
    meta?: NotificationMetaType;
    expiresAt?: Date;
}

export interface UpdateNotificationRequest {
    title?: string;
    body?: string;
    severity?: NotificationSeverity;
    meta?: NotificationMetaType;
    isRead?: boolean;
}

export interface NotificationConfig {
    storeId: string;
    userId: string;
    source: string;
}

export enum NotificationType {
    SUCCESS = 'success',
    ERROR = 'error',
    WARNING = 'warning',
    INFO = 'info'
}

export enum NotificationSeverity {
    LOW = 'low',
    MEDIUM = 'medium',
    HIGH = 'high',
    CRITICAL = 'critical'
}